<template>
  <AppDialog
    v-model="visible"
    :title="title"
    width="1377px"
    height="593px"
    top="10vh"
    @success="successFn"
  >
    <div v-loading="loading" class="choose_resource">
      <div class="window-search">
        <span
          v-if="
            [
              '0',
              '1',
              '2',
              '3',
              '4',
              '5',
              '51',
              '7',
              '10',
              'selectedRoundGoods'
            ].includes(currentId) && tearchSearch
          "
          class="text"
        >IP</span>
        <TeacherSelect
          v-if="
            [
              '0',
              '1',
              '2',
              '3',
              '4',
              '5',
              '51',
              '7',
              '10',
              'selectedRoundGoods'
            ].includes(currentId) && tearchSearch
          "
          ref="teacherSelect"
          class="m-r-20"
          placeholder="请选择IP"
          :default-tearch-id="tearch.lecturerId"
          :value="tearch.lecturerName"
          @selected="teacherSelect"
        />
        <m-select
          v-if="
            [
              '0',
              '1',
              '2',
              '3',
              '4',
              '5',
              '51',
              '7',
              '10',
              'selectedRoundGoods'
            ].includes(currentId) && tearchSearch
          "
          v-model="singleLecture"
          :clearable="false"
          dict-key="singleLectureType"
          style="width: 140px"
          size="small"
          class="m-r-20"
        />
        <!-- <span class="text">商品名称</span> -->
        <!-- <el-input v-model.trim="search" class="m-r-20" style="width: 160px" :placeholder="getPlaceholder()" prefix-icon="el-icon-search" clearable size="small" @keyup.enter.native="searchFn" @clear="searchFn" /> -->
        <div class="order-time-box">
          <el-select
            v-model="searchType"
            placeholder="请选择"
            size="small"
            class="input-with-select input-with-select-chang"
          >
            <el-option label="商品名称" :value="1" />
            <el-option label="商品ID" :value="2" />
          </el-select>
          <el-input
            v-if="searchType === 1"
            v-model.trim="search"
            class="filter_teacherSelect m-r-20"
            style="width: 160px"
            placeholder="请输入商品名称"
            clearable
            size="small"
            @keyup.enter.native="searchFn"
            @clear="searchFn"
          />
          <el-input
            v-else
            v-model.trim="searchGoodsId"
            class="filter_teacherSelect m-r-20"
            style="width: 160px"
            placeholder="请输入商品id"
            clearable
            size="small"
            @keyup.enter.native="searchFn"
            @clear="searchFn"
          />
        </div>

        <AppGradeTagSelect
          v-if="showGradeTagFilter"
          v-model="gradeTag"
          :options="gradeTagOptions"
          :show-status-options="false"
          class="m-r-20"
          width="200px"
          size="small"
          placeholder="请选择交付年级标签"
          @change="searchFn"
        />

        <div
          v-if="
            isSearchPrice &&
              ['0', '1', '2', '3', '4', '5', '7', '10'].includes(currentId)
          "
          class="moneyBox m-r-20"
        >
          <span class="text">价格</span>
          <el-input-number
            v-model="starSalePrice"
            size="small"
            placeholder="请输入"
            style="width: 139px"
            :controls="false"
          />
          <span class="m-l-10 m-r-10">-</span>
          <el-input-number
            v-model="endSalePrice"
            size="small"
            placeholder="请输入"
            style="width: 139px"
            :controls="false"
          />
        </div>
        <template v-if="['A7'].includes(currentId) && showCourseType">
          <span class="text">课程标签</span>
          <el-select
            v-model="courseType"
            clearable
            placeholder="请选择"
            size="small"
            class="m-r-20"
            @clear="searchFn"
          >
            <el-option label="视频课" :value="0" />
            <el-option label="训练营" :value="1" />
          </el-select>
        </template>
        <el-button
          size="small"
          type="primary"
          class="search_btn search_paramy"
          @click="searchFn"
        >查询</el-button>
        <el-button
          size="small"
          class="search_btn"
          @click="searchReset"
        >重置</el-button>
      </div>
      <!-- 大专栏开启延迟发放权益时，提示只能关联已配置交付年级标签的专栏 -->
      <div v-if="showGradeTag" class="delay-grant-tip">
        当前大专栏已开启「延迟发放权益」，只能关联已配置交付年级标签的专栏，未打标签的专栏不可勾选
      </div>
      <div class="window-tab">
        <div class="tab-wrapper">
          <el-tabs v-model="currentId" class="tab-item" @tab-click="changTab">
            <el-tab-pane
              v-for="item in tabList"
              :key="item.id"
              :label="item.name"
              :name="item.id"
              :disabled="Boolean(item.disabled)"
            />
          </el-tabs>
        </div>
        <div class="tab-slort">
          <span>排序：</span>
          <m-select
            v-model="slort"
            dict-key="COMMODITY_SORT"
            size="small"
            @change="handleSlortChage"
          />
        </div>
      </div>
      <div class="window-list" :class="{ 'with-grade-tip': showGradeTag }">
        <div class="resource-item-wrapper">
          <template
            v-if="
              ['0', '1', '2', '3', '4', '5', '6', '10', '99', 'selectedRoundGoods'].includes(
                currentId
              )
            "
          >
            <div
              class="resource-item-wrapper-box"
              :class="{ noMultiple: !multiple }"
            >
              <el-checkbox-group v-if="multiple" v-model="checkList">
                <el-checkbox
                  v-for="(item, index) in tableData"
                  :key="item.goodsId"
                  :label="item.goodsId"
                  :disabled="
                    check.includes(item.goodsId) || shouldDisableItem(item)
                  "
                  @change="res => checkChange(res, item, index)"
                >
                  <div class="resource-item-wrapper-box-group">
                    <div class="item-wrapper">
                      <ImagePreviewer
                        class="image-previewer"
                        :src="item.coverVerticalUrl"
                        alt=""
                        fit="contain"
                      />
                      <div class="item-info">
                        <div class="item-name-line">
                          <div class="item-name">{{ item.contentName }}</div>
                          <span
                            v-if="showMultiSpecTag && isMultiSpec(item)"
                            class="item-spec-count"
                          >{{ multiSpecCount(item) }} 个规格</span>
                        </div>
                        <div class="item-info-row2">
                          <span
                            v-if="isPlaform"
                            style="
                              color: #333;
                              line-height: 24px;
                              font-weight: 600;
                            "
                            class="m-r-10"
                          >{{ item.tenantVO.tenantName + ' ' }}</span>
                          <div
                            v-if="item.saleType === 0"
                            class="item-price m-r-10"
                          >
                            免费
                          </div>
                          <div
                            v-if="item.saleType === 2"
                            class="item-price m-r-10"
                          >
                            加密
                          </div>
                          <!-- 0: '已上架#00b42a #E6F7EA el-icon-success', 1: '已下架#F53F3F #FEECEC el-icon-error', 2: '待上架#FF7D00 #FFF2E6 el-icon-time' -->
                          <AppTag
                            v-if="[0, 1, 2].includes(item.shelveFlag)"
                            :bg-color="getShelveFlagBgColor(item.shelveFlag)"
                          >
                            <template slot="icon">
                              <i
                                :class="getShelveFlagClass(item.shelveFlag)"
                                :style="{
                                  color: {
                                    0: '#00b42a',
                                    1: '#F53F3F',
                                    2: '#FF7D00'
                                  }[item.shelveFlag]
                                }"
                              />
                            </template>
                            <template slot="text">
                              <span
                                :style="{
                                  color: {
                                    0: '#00b42a',
                                    1: '#F53F3F',
                                    2: '#FF7D00'
                                  }[item.shelveFlag]
                                }"
                              >{{
                                { 0: '已上架', 1: '已下架', 2: '待上架' }[
                                  item.shelveFlag
                                ]
                              }}</span>
                            </template>
                          </AppTag>
                          <div
                            v-if="showGradeTagFilter"
                            class="item-grade-tag item-price--right"
                          >{{ item.gradeTagNames || '--' }}</div>
                          <i class="item-row2-gap" />
                          <div
                            v-if="showRangePrice(item)"
                            class="item-price item-price--right"
                          >￥{{ specPriceRange(item) }}</div>
                          <div
                            v-else-if="Number(item.saleType) === 1"
                            class="item-price item-price--right"
                          >￥{{ formatPrice(item) }}</div>
                          <!-- saleType 为 null/0/2（免费/加密）时兜底：只要顶层有 salePrice 就显示 -->
                          <div
                            v-else-if="item.salePrice !== undefined && item.salePrice !== null && item.salePrice !== ''"
                            class="item-price item-price--right"
                          >￥{{ formatPrice(item) }}</div>
                        </div>
                        <!-- 多规格课程：勾选后需指定具体规格（默认选中第一个，可切换，必须选一个） -->
                        <div
                          v-if="selectSpec && isMultiSpec(item) && checkList.includes(item.goodsId)"
                          class="spec-select-panel"
                          @click.stop
                        >
                          <div class="spec-select-options">
                            <button
                              v-for="sku in getSpecList(item)"
                              :key="getSpecKey(sku)"
                              type="button"
                              class="spec-option"
                              :class="{
                                active: isSkuSelected(item, sku),
                                'spec-option--disabled': isSkuOutOfStock(sku)
                              }"
                              :disabled="isSkuOutOfStock(sku)"
                              @click.stop="handleSelectSku(item, sku)"
                            >{{ getSpecLabel(sku) }}{{ isSkuOutOfStock(sku) ? '（库存不足）' : '' }}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="packagePrice" class="packageInputView">
                      <span class="packageInputViewText">套餐单价</span>
                      <el-input-number
                        v-model="item.packagePrice"
                        :min="0"
                        size="small"
                        placeholder="请输入"
                        style="width: 262px; text-align: left"
                        :controls="false"
                      />
                    </div>
                  </div>
                </el-checkbox>
              </el-checkbox-group>
              <el-radio-group v-else v-model="selectedSingleValue">
                <el-radio
                  v-for="item in tableData"
                  :key="item.goodsId"
                  :label="item.goodsId"
                  :disabled="
                    check.includes(item.goodsId) || shouldDisableItem(item)
                  "
                >
                  <div class="resource-item-wrapper-box-group">
                    <div class="item-wrapper">
                      <ImagePreviewer
                        class="image-previewer"
                        :src="item.coverVerticalUrl"
                        alt=""
                        fit="contain"
                      />
                      <div class="item-info">
                        <div class="item-name-line">
                          <div class="item-name">{{ item.contentName }}</div>
                          <span
                            v-if="showMultiSpecTag && isMultiSpec(item)"
                            class="item-spec-count"
                          >{{ multiSpecCount(item) }} 个规格</span>
                        </div>
                        <div class="item-info-row2">
                          <span
                            v-if="isPlaform"
                            style="
                              color: #333;
                              line-height: 24px;
                              font-weight: 600;
                            "
                            class="m-r-10"
                          >{{ item.tenantVO.tenantName + ' ' }}</span>
                          <div
                            v-if="item.saleType === 0"
                            class="item-price m-r-10"
                          >
                            免费
                          </div>
                          <div
                            v-if="item.saleType === 2"
                            class="item-price m-r-10"
                          >
                            加密
                          </div>
                          <!-- 0: '已上架#00b42a #E6F7EA el-icon-success', 1: '已下架#F53F3F #FEECEC el-icon-error', 2: '待上架#FF7D00 #FFF2E6 el-icon-time' -->
                          <AppTag
                            v-if="[0, 1, 2].includes(item.shelveFlag)"
                            :bg-color="getShelveFlagBgColor(item.shelveFlag)"
                          >
                            <template slot="icon">
                              <i
                                :class="getShelveFlagClass(item.shelveFlag)"
                                :style="{
                                  color: {
                                    0: '#00b42a',
                                    1: '#F53F3F',
                                    2: '#FF7D00'
                                  }[item.shelveFlag]
                                }"
                              />
                            </template>
                            <template slot="text">
                              <span
                                :style="{
                                  color: {
                                    0: '#00b42a',
                                    1: '#F53F3F',
                                    2: '#FF7D00'
                                  }[item.shelveFlag]
                                }"
                              >{{
                                { 0: '已上架', 1: '已下架', 2: '待上架' }[
                                  item.shelveFlag
                                ]
                              }}</span>
                            </template>
                          </AppTag>
                          <div
                            v-if="showGradeTagFilter"
                            class="item-grade-tag"
                          >交付年级标签：{{ item.gradeTagNames || '--' }}</div>
                          <i class="item-row2-gap" />
                          <div
                            v-if="showRangePrice(item)"
                            class="item-price"
                          >￥{{ specPriceRange(item) }}</div>
                          <div
                            v-else-if="Number(item.saleType) === 1"
                            class="item-price item-price--right"
                          >￥{{ formatPrice(item) }}</div>
                          <!-- saleType 为 null/0/2（免费/加密）时兜底：只要顶层有 salePrice 就显示 -->
                          <div
                            v-else-if="item.salePrice !== undefined && item.salePrice !== null && item.salePrice !== ''"
                            class="item-price item-price--right"
                          >￥{{ formatPrice(item) }}</div>
                        </div>
                        <!-- 多规格课程：勾选后需指定具体规格（默认选中第一个，可切换，必须选一个） -->
                        <div
                          v-if="selectSpec && isMultiSpec(item) && checkList.includes(item.goodsId)"
                          class="spec-select-panel"
                          @click.stop
                        >
                          <div class="spec-select-options">
                            <button
                              v-for="sku in getSpecList(item)"
                              :key="getSpecKey(sku)"
                              type="button"
                              class="spec-option"
                              :class="{
                                active: isSkuSelected(item, sku),
                                'spec-option--disabled': isSkuOutOfStock(sku)
                              }"
                              :disabled="isSkuOutOfStock(sku)"
                              @click.stop="handleSelectSku(item, sku)"
                            >{{ getSpecLabel(sku) }}{{ isSkuOutOfStock(sku) ? '（库存不足）' : '' }}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="packagePrice" class="packageInputView">
                      <span class="packageInputViewText">套餐单价</span>
                      <el-input-number
                        v-model="item.packagePrice"
                        :min="0"
                        size="small"
                        placeholder="请输入"
                        style="width: 262px; text-align: left"
                        :controls="false"
                      />
                    </div>
                  </div>
                </el-radio>
              </el-radio-group>

              <div
                v-if="tableData && tableData.length === 0"
                class="resource-item-wrapper-box-noData"
              >
                <img src="~@/assets/image/zanwusousuoneirong2.png" alt="" />
                <div class="m-t-10 noDataText">暂无数据</div>
              </div>
            </div>
          </template>

          <template v-else-if="['8', '9'].includes(currentId)">
            <div class="ss-material-main-tree">
              <div class="ss-material-main-tree-left">
                <AppTree
                  v-model="classlist"
                  v-loading="loading"
                  style="width: 200px"
                  :loading="treeLoading"
                  :nobtn="true"
                  @node-click="treeClick"
                />
              </div>
              <div class="ss-material-main-tree-right">
                <el-checkbox-group v-model="checkList">
                  <el-checkbox
                    v-for="(item, index) in tableData"
                    :key="item.materialId"
                    :label="item.materialId"
                    :disabled="
                      check.includes(item.materialId) ||
                        (['Transcoding', 'Uploading', 'Checking'].includes(
                          item.status
                        ) &&
                          item.transcodeProgress !== 100)
                    "
                    @change="res => checkChange(res, item, index)"
                  >
                    <div
                      class="resource-item-wrapper-box-group"
                      style="width: 1067px"
                    >
                      <div class="item-wrapper">
                        <img
                          v-if="currentId === '8'"
                          :src="item.materialFrameUrl"
                          alt=""
                          style="width: 60px; height: 60px"
                        />
                        <svg-icon
                          v-if="currentId === '9'"
                          class-name="size-icon"
                          style="width: 60px; height: 60px; font-size: 60px"
                          icon-class="audio"
                          @click="play(row.materialUrl)"
                        />
                        <div class="item-info">
                          <div class="item-name">{{ item.materialName }}</div>
                          <div
                            v-if="
                              ['Transcoding', 'Uploading', 'Checking'].includes(
                                item.status
                              ) && item.transcodeProgress !== 100
                            "
                          >
                            视频解码中，解码完成{{
                              item.transcodeProgress
                            }}%，请解码成功再加入课程
                            <el-button
                              size="mini"
                              @click="handleRefreshItem(item)"
                            >刷新进度</el-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-checkbox>
                </el-checkbox-group>
                <div v-if="tableData.length === 0" class="noData">暂无数据</div>
              </div>
            </div>
          </template>

          <template v-else-if="['51'].includes(currentId)">
            <div
              class="resource-item-wrapper-box"
              :class="{ noMultiple: !multiple }"
            >
              <el-checkbox-group v-model="checkList">
                <el-checkbox
                  v-for="(item, index) in tableData"
                  :key="item.specId"
                  :label="item.specId"
                  :disabled="
                    check.includes(item.specId) || shouldDisableItem(item)
                  "
                  @change="res => checkChange(res, item, index)"
                >
                  <div class="item-wrapper">
                    <ImagePreviewer
                      class="image-previewer"
                      :src="
                        item.contentUrl ? item.contentUrl.split(',')[0] : ''
                      "
                      alt=""
                      fit="contain"
                    />
                    <div class="item-info">
                      <div class="item-name">{{ item.goodsName }}</div>
                      <div class="item-price">
                        <el-tag size="mini">{{ item.specName }}</el-tag>
                      </div>
                      <div class="item-price">￥{{ formatPrice(item) }}</div>
                    </div>
                  </div>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </template>

          <template v-else-if="['7'].includes(currentId)">
            <div
              ref="resourceItemWrapperBox"
              class="resource-item-wrapper-box"
              :class="{ noMultiple: !multiple }"
            >
              <div
                v-for="(item, index) in tableData"
                :id="'packageCoure-check-view-group' + item.goodsId"
                :key="item.goodsId"
                class="packageCoure-check-view-group"
                :label="item.goodsId"
              >
                <div
                  class="packageCoure-item-wrapper-box-group"
                  @click="onClickPackageCourse(item.goodsId, item, index)"
                >
                  <div class="m-r-10">
                    <el-checkbox
                      :value="checkList.includes(item.goodsId)"
                      :disabled="
                        check.includes(item.goodsId) || shouldDisableItem(item)
                      "
                      @change="onClickPackageCourse(item.goodsId, item, index)"
                    />
                  </div>
                  <div class="packageCoure-item-wrapper">
                    <ImagePreviewer
                      class="image-previewer"
                      :src="item.coverVerticalUrl"
                      alt=""
                      fit="contain"
                    />
                    <div class="packageCoure-item-info">
                      <div class="item-name">{{ item.contentName }}</div>
                      <div style="display: flex">
                        <span
                          v-if="isPlaform"
                          style="
                            color: rgb(51, 51, 51);
                            line-height: 24px;
                            font-weight: 600;
                          "
                          class="m-r-10"
                        >{{ item.tenantVO.tenantName + ' ' }}</span>
                        <div
                          v-if="item.saleType === 0"
                          class="item-price m-r-10"
                        >
                          免费
                        </div>
                        <div
                          v-if="item.saleType === 2"
                          class="item-price m-r-10"
                        >
                          加密
                        </div>
                        <div
                          v-if="item.saleType === 1"
                          class="item-price m-r-10"
                        >
                          ￥{{ formatPrice(item) }}
                        </div>
                        <AppTag
                          v-if="[0, 1, 2].includes(item.shelveFlag)"
                          :bg-color="
                            { 0: '#E6F7EA', 1: '#FEECEC', 2: '#FFF2E6' }[
                              item.shelveFlag
                            ]
                          "
                        >
                          <template slot="icon">
                            <i
                              :class="
                                {
                                  0: 'el-icon-success',
                                  1: 'el-icon-error',
                                  2: 'el-icon-time'
                                }[item.shelveFlag]
                              "
                              :style="{
                                color: {
                                  0: '#00b42a',
                                  1: '#F53F3F',
                                  2: '#FF7D00'
                                }[item.shelveFlag]
                              }"
                            />
                          </template>
                          <template slot="text">
                            <span
                              :style="{
                                color: {
                                  0: '#00b42a',
                                  1: '#F53F3F',
                                  2: '#FF7D00'
                                }[item.shelveFlag]
                              }"
                            >{{
                              { 0: '已上架', 1: '已下架', 2: '待上架' }[
                                item.shelveFlag
                              ]
                            }}</span>
                          </template>
                        </AppTag>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="item.children && item.children.length > 0"
                    class="packageCoure-item-wrapper-left"
                    @click.stop="onhandleOpen(item)"
                  >
                    <div class="btn-left">
                      {{ item.childrenOpen ? '收起' : '展开'
                      }}<i
                        :class="
                          item.childrenOpen
                            ? 'el-icon-arrow-down'
                            : 'el-icon-arrow-right'
                        "
                      />
                    </div>
                  </div>
                </div>

                <div
                  v-if="item.childrenOpen"
                  class="packageCoure-item-children"
                >
                  <div
                    v-for="c in item.children"
                    :key="c.goodsId"
                    class="packageCoure-item-wrapper-box-group"
                    style="padding: 18px 0px 0px 50px"
                  >
                    <div class="packageCoure-item-wrapper">
                      <ImagePreviewer
                        class="image-previewer"
                        :src="c.coverVerticalUrl"
                        alt=""
                        fit="contain"
                      />
                      <div class="packageCoure-item-info">
                        <div class="item-chidren-name">
                          <span class="item-name">{{ c.contentName }}</span>
                          <span
                            v-if="
                              (c.goodsType === 3 || c.goodsType === 4) &&
                                c.productCategory === 0
                            "
                            style="margin-left: 15px"
                            class="item-chidren-type"
                          >录播课</span>
                          <span
                            v-if="
                              (c.goodsType === 3 || c.goodsType === 4) &&
                                c.productCategory === 2
                            "
                            style="margin-left: 15px"
                            class="item-chidren-type"
                          >线下课</span>
                          <span
                            v-if="
                              (c.goodsType === 3 || c.goodsType === 4) &&
                                c.productCategory === 1
                            "
                            style="margin-left: 15px"
                            class="item-chidren-type item-chidren-type-live"
                          >训练营</span>
                        </div>
                        <div class="item-info-row2">
                          <div
                            v-if="c.saleType === 0"
                            class="item-price m-r-10"
                          >
                            免费
                          </div>
                          <div
                            v-if="c.saleType === 2"
                            class="item-price m-r-10"
                          >
                            加密
                          </div>
                          <div
                            v-if="c.saleType === 1"
                            class="item-price m-r-10"
                          >
                            ￥{{ formatPrice(c) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="tableData && tableData.length === 0"
                class="resource-item-wrapper-box-noData"
              >
                <img src="~@/assets/image/zanwusousuoneirong2.png" alt="" />
                <div class="m-t-10 noDataText">暂无数据</div>
              </div>
            </div>
          </template>

          <template v-else-if="['A7'].includes(currentId)">
            <div ref="resourceItemWrapperBox" class="resource-item-wrapper-box">
              <div
                v-for="(item, index) in tableData"
                :id="'packageCoure-check-view-group' + item.goodsId"
                :key="item.goodsId"
                class="packageCoure-check-view-group"
                :label="item.goodsId"
              >
                <div class="packageCoure-item-wrapper-box-group">
                  <div class="m-r-10" :class="{ noMultiple: !multiple }">
                    <el-checkbox
                      :indeterminate="
                        packageCoure_checkList[item.goodsId] &&
                          packageCoure_checkList[item.goodsId].length > 0 &&
                          packageCoure_checkList[item.goodsId].length !==
                          item.liveCourseNum
                      "
                      :value="ifCheckAll(item)"
                      :disabled="
                        item.liveCourseNum === 0 || shouldDisableItem(item)
                      "
                      @change="
                        res =>
                          onClickPackageA7Course(item.goodsId, item, index, res)
                      "
                    />
                  </div>
                  <div
                    class="packageCoure-item-wrapper"
                    @click.stop="
                      onClickPackageA7Course(
                        item.goodsId,
                        item,
                        index,
                        !ifCheckAll(item)
                      )
                    "
                  >
                    <ImagePreviewer
                      class="image-previewer"
                      :src="item.coverVerticalUrl"
                      alt=""
                      fit="contain"
                    />
                    <div class="packageCoure-item-info">
                      <div class="item-name">{{ item.contentName }}</div>
                      <span v-if="isPlaform" style="color: #000">{{
                        item.tenantVO.tenantName + ' '
                      }}</span>
                      <div style="display: flex">
                        <div
                          v-if="item.saleType === 0"
                          class="item-price m-r-10"
                        >
                          免费
                        </div>
                        <div
                          v-if="item.saleType === 2"
                          class="item-price m-r-10"
                        >
                          加密
                        </div>
                        <div
                          v-if="item.saleType === 1"
                          class="item-price m-r-10"
                        >
                          ￥{{ formatPrice(item) }}
                        </div>
                        <AppTag
                          v-if="[0, 1, 2].includes(item.shelveFlag)"
                          :bg-color="
                            { 0: '#E6F7EA', 1: '#FEECEC', 2: '#FFF2E6' }[
                              item.shelveFlag
                            ]
                          "
                        >
                          <template slot="icon">
                            <i
                              :class="
                                {
                                  0: 'el-icon-success',
                                  1: 'el-icon-error',
                                  2: 'el-icon-time'
                                }[item.shelveFlag]
                              "
                              :style="{
                                color: {
                                  0: '#00b42a',
                                  1: '#F53F3F',
                                  2: '#FF7D00'
                                }[item.shelveFlag]
                              }"
                            />
                          </template>
                          <template slot="text">
                            <span
                              :style="{
                                color: {
                                  0: '#00b42a',
                                  1: '#F53F3F',
                                  2: '#FF7D00'
                                }[item.shelveFlag]
                              }"
                            >{{
                              { 0: '已上架', 1: '已下架', 2: '待上架' }[
                                item.shelveFlag
                              ]
                            }}</span>
                          </template>
                        </AppTag>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="item.children"
                    class="packageCoure-item-wrapper-left"
                    @click.stop="onhandleOpen(item)"
                  >
                    <div class="btn-left">
                      {{ item.childrenOpen ? '收起' : '展开'
                      }}<i
                        :class="
                          item.childrenOpen
                            ? 'el-icon-arrow-down'
                            : 'el-icon-arrow-right'
                        "
                      />
                    </div>
                  </div>
                </div>

                <div
                  v-if="item.childrenOpen"
                  class="packageCoure-item-children"
                >
                  <div
                    v-for="c in item.children"
                    :key="c._goodsId"
                    class="packageCoure-item-wrapper-box-group"
                    style="padding: 18px 0px 0px 25px"
                  >
                    <div class="packageCoure-item-wrapper">
                      <div class="m-r-10">
                        <el-checkbox
                          :value="checkList.includes(c._goodsId)"
                          :disabled="
                            !(
                              (c.goodsType === 3 || c.goodsType === 4) &&
                              c.productCategory === 1
                            ) ||
                              check.includes(c._goodsId) ||
                              shouldDisableItem(c)
                          "
                          @change="
                            onClickA7PackageCourse(c._goodsId, c, index, item)
                          "
                        />
                      </div>
                      <ImagePreviewer
                        class="image-previewer"
                        :src="c.coverVerticalUrl"
                        alt=""
                        fit="contain"
                      />
                      <div
                        class="packageCoure-item-info"
                        @click.stop="
                          onClickA7PackageCourse(c._goodsId, c, index, item)
                        "
                      >
                        <div class="item-chidren-name">
                          <span class="item-name">{{ c.contentName }}</span>
                          <span
                            v-if="
                              (c.goodsType === 3 || c.goodsType === 4) &&
                                c.productCategory === 0
                            "
                            style="margin-left: 15px"
                            class="item-chidren-type"
                          >录播课</span>
                          <span
                            v-if="
                              (c.goodsType === 3 || c.goodsType === 4) &&
                                c.productCategory === 2
                            "
                            style="margin-left: 15px"
                            class="item-chidren-type item-chidren-type-offline"
                          >线下课</span>
                          <span
                            v-if="
                              (c.goodsType === 3 || c.goodsType === 4) &&
                                c.productCategory === 1
                            "
                            style="margin-left: 15px"
                            class="item-chidren-type item-chidren-type-live"
                          >训练营</span>
                        </div>
                        <span v-if="isPlaform" style="color: #000">{{
                          c.tenantVO.tenantName + ' '
                        }}</span>
                        <div class="item-info-row2">
                          <div
                            v-if="c.saleType === 0"
                            class="item-price m-r-10"
                          >
                            免费
                          </div>
                          <div
                            v-if="c.saleType === 2"
                            class="item-price m-r-10"
                          >
                            加密
                          </div>
                          <div
                            v-if="c.saleType === 1"
                            class="item-price m-r-10"
                          >
                            ￥{{ formatPrice(c) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="tableData && tableData.length === 0"
                class="resource-item-wrapper-box-noData"
              >
                <img src="~@/assets/image/zanwusousuoneirong2.png" alt="" />
                <div class="m-t-10 noDataText">暂无数据</div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div slot="footer" class="dialogFooter">
      <div class="flex">
        <div v-if="multiple" class="check-all">
          <el-checkbox
            v-model="checkedAll"
            :disabled="disabledAllFn"
            @change="handleCheckAll"
          >全选</el-checkbox>
        </div>
        <el-pagination
          v-if="!['A7'].includes(currentId)"
          layout="jumper, prev, pager, next, sizes, total"
          :total="total"
          :page-size="size"
          :current-page="current"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
      <div class="dialogFooterRight">
        <el-button
          type="primary"
          class="search_btn search_paramy"
          :disabled="!hasSelectedGoods"
          @click="successFn()"
        >{{ confirmText }}</el-button>
        <el-button class="search_btn" @click="close()">取消</el-button>
      </div>
    </div>
  </AppDialog>
</template>

<script>
const videoStatus = {
  Uploading: '上传中',
  UploadFail: '上传失败',
  UploadSucc: '上传完成',
  Transcoding: '转码中',
  Checking: '审核中',
  Blocked: '屏蔽',
  Normal: '正常',
  ProduceFail: '合成失败'
}
// 商品类型名称（与后端 GoodsTypeEnum 一致）
const GOODS_TYPE_NAME = {
  0: '图文',
  1: '音频',
  2: '视频',
  3: '专栏',
  4: '大专栏',
  5: '线下课',
  6: '直播专栏',
  7: '套餐课',
  8: '训练营'
}
import AppDialog from '@/components/AppDialog'
import AppTag from '@/components/AppTag'
import {
  getMerchantRoundGoods,
  getGoodsList,
  materialPage,
  getOfflineGoodsSpecPage,
  platformGoodsList,
  getMaterialGoodsByType,
  updateMaterialStatus,
  getExternalLinkGoodsPage
} from '@/api/course'
import { getLiveList } from '@/api/privateArea/class'
import { getGradeVersionTree } from '@/api/deliver/dict'
import { cancelMerchantToBusinessData } from '@/api/business/multiMerchant'
import TeacherSelect from '@/views/deliver/components/tearchSelect.vue'
import store from '@/store'
import router from '@/router'
import AppTree from '@/components/AppTree'
import AppGradeTagSelect from '@/components/AppGradeTagSelect'
export default {
  components: {
    AppTag,
    AppDialog,
    AppTree,
    TeacherSelect,
    AppGradeTagSelect
  },
  props: {
    // 是否展示套餐课价格输入框
    packagePrice: {
      type: Boolean,
      default: false
    },
    // 是否展示课程标签搜索条件
    showCourseType: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '选择'
    },
    // 禁选项目
    check: {
      type: Array,
      default: () => {
        return []
      }
    },
    success: {
      type: Function,
      default: () => {
        return () => {}
      }
    },
    isSearchPrice: {
      type: Boolean,
      default: false
    },
    // 是否多选
    multiple: {
      type: Boolean,
      default: true
    },
    initSearch: {
      type: Object,
      default: undefined
    },
    // 选中项
    defaultValue: {
      type: Array,
      default: () => {
        return []
      }
    },
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 选中的商品信息 二次修改时需要用到
    goodsInfo: {
      type: Array,
      default: () => {
        return []
      }
    },
    tearchSearch: {
      type: Boolean,
      default: false
    },
    filterateHidden: {
      type: Boolean,
      default: false
    },
    currentId: {
      type: String,
      default: '4'
    },
    isPlaform: {
      type: Boolean,
      default: false
    },
    sameSelected: {
      type: Boolean,
      default: false
    },
    // 是否启用交付年级标签筛选（大专栏开启延迟发放权益时添加专栏场景）
    showGradeTag: {
      type: Boolean,
      default: false
    },
    // 确定按钮文字
    confirmText: {
      type: String,
      default: '确定'
    },
    // 勾选单个商品前的校验回调（仅多选勾选时触发）：
    // 入参 (item, checkedItems-已选中的其他商品)，返回错误文案则回滚本次勾选并提示，返回空串/undefined 放行
    beforeCheck: {
      type: Function,
      default: null
    },
    // 是否展示"N 个规格"标签及多规格价格区间（商品需返回 multiWarehouseSkuList 字段）
    showMultiSpecTag: {
      type: Boolean,
      default: true
    },
    // 勾选多规格课程后是否必须指定具体规格（确认时校验，选中规格挂载到 item.selectedSku）
    selectSpec: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      videoStatus,
      uniqueArr: [],
      selectedTableData: [],
      checkedAll: false,
      saleType: '',
      starSalePrice: undefined,
      endSalePrice: undefined,
      slort: 0,
      courseType: '',
      options: [
        { value: '', label: '全部' },
        { value: 0, label: '免费' },
        { value: 1, label: '付费' }
      ],
      singleLecture: 1,
      loading: false,
      search: '',
      searchGoodsId: '',
      searchType: 1, // 1商品名称 2: 商品Id
      goodsName: '',
      tearch: {
        lecturerId: '',
        lecturerName: ''
      },
      tabList: [
        { id: '0', name: '图文', api: '' },
        { id: '1', name: '音频', api: '' },
        { id: '2', name: '视频', api: '' },
        { id: '3', name: '普通专栏', api: '' },
        { id: '4', name: '大专栏', api: '' },
        { id: '5', name: '线下课', api: '' },
        { id: '6', name: '直播专栏', api: '' },
        { id: '8', name: '视频素材', api: '' },
        { id: '9', name: '音频素材', api: '' },
        { id: '99', name: '外链商品', api: '' }
        // { id: '5', name: '公开课', api: '' },
        // { id: '6', name: '一对一', api: '' },
        // { id: '7', name: '落地班', api: '' },
        // { id: '10', name: '直播课', api: '' }, 10为直播课，goodstype为8，
      ],
      disabledFn: () => false,
      // currentId: '4',
      checkList: [], // 记录id
      checkListInfo: [], // 记录对象
      checkListAllInfo: [],
      current: 1,
      size: 10,
      total: 0,
      tableData: [],
      noMore: false,
      form: {
        id: '',
        name: ''
      },
      changeLoading: false, // 加个loading防止点击过快
      classlist: [],
      treeLoading: false,
      onlineFlag: 0, // 是否线上(0线上，1线下)
      shelveHideFlag: '',
      packageChildren: [], // 套餐课的子课
      packageCoure_checkList: {},
      selectedSingleValue: '', // 单选模式下的选中值
      gradeTag: [], // 交付年级标签：[年级val, 教材版本val]
      gradeTagOptions: [], // 交付年级标签树形选项（年级-教材版本）
      // selectedRoundGoods 相关：记录已加载的页和被手动取消的商品ID
      roundGoodsLoadedPages: new Set(),
      roundGoodsUncheckedIds: new Set(),
      // selectSpec 模式下，多规格课程选中的具体规格：{ [goodsId]: skuItem }
      selectedSkuMap: {}
    }
  },
  computed: {
    // 大专栏开启延迟发放权益（showGradeTag）且当前操作人有权限时，才显示交付年级标签查询条件和标签信息
    // 本组件由 $SelectGoods 插件以独立实例挂载，this.$route 不可用，需从全局 router 取当前路由的权限码
    showGradeTagFilter() {
      const permsList =
        (router.currentRoute.meta && router.currentRoute.meta.permsList) || []
      return (
        this.showGradeTag &&
        permsList.includes('collegeColumnDetail:goods:gradeTag')
      )
    },
    // 判断是否有选中的商品
    hasSelectedGoods() {
      // 当tab为selectedRoundGoods时，允许不选商品点击确定
      if (this.currentId === 'selectedRoundGoods') {
        return true
      }
      if (this.multiple) {
        return this.checkList && this.checkList.length > 0
      } else {
        return !!this.selectedSingleValue
      }
    },
    // noMore() {
    //   return this.tableData.length >= this.total
    // },
    disabled() {
      return this.loading || this.noMore
    },
    disabledAllFn() {
      if (
        ['0', '1', '2', '3', '4', '5', '6', '7', 'A7', '10', '99', 'selectedRoundGoods'].includes(
          this.currentId
        )
      ) {
        const arr = this.tableData.map(v => v.goodsId)
        return arr.every(v => this.check.includes(v))
      } else if (['8', '9'].includes(this.currentId)) {
        const arr = this.tableData.map(v => v.materialId)
        return arr.every(v => this.check.includes(v))
      } else if (['51'].includes(this.currentId)) {
        const arr = this.tableData.map(v => v.specId)
        return arr.every(v => this.check.includes(v))
      }
      return false
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          console.log('打开弹框')
          // 每次打开对话框时，清空临时保存的勾选结果数据
          this.roundGoodsUncheckedIds = new Set()
          this.roundGoodsLoadedPages = new Set()
          this.init()
        }
      },
      deep: true,
      immediate: true
    },
    checkList: {
      handler(val) {
        this.get_packageCoure_checkList()
      },
      deep: true,
      immediate: true
    },
    tableData: {
      handler(val) {
        if (!val?.length) {
          this.checkedAll = false
        } else {
          this.checkedAll =
            this?.tableData?.length &&
            this.tableData.every(v => this.checkList.includes(v.goodsId))
        }
      },
      immediate: true,
      deep: true
    },
    checkListInfo: {
      handler(val) {
        // 相同类型且没有已选中的商品
        if (
          this.sameSelected &&
          this.check?.length === 0 &&
          val?.length === 1
        ) {
          // 只能选择相同类型
          this.tabList.forEach(item => {
            if (this.currentId !== item.id) {
              item.disabled = true
            }
            if (
              ['2', '8'].includes(this.currentId) &&
              ['2', '8'].includes(item.id)
            ) {
              // 2, 8同为视频类型
              item.disabled = false
            }
          })
        } else if (
          this.sameSelected &&
          this.check?.length === 0 &&
          val?.length === 0
        ) {
          this.tabList.forEach(item => {
            item.disabled = false
          })
        }
      },
      deep: true,
      immediate: true
    },
    selectedSingleValue: {
      handler(val) {
        if (!this.multiple && val) {
          // 单选模式下，同步更新 checkList 和 checkListInfo
          this.checkList = [val]
          const item = this.tableData.find(i => i.goodsId === val)
          if (item) {
            this.checkListInfo = [item]
            // 多规格课程：单选勾选后自动默认选中第一个规格
            this.ensureDefaultSkuSelected(item)
          }
        }
      },
      immediate: false
    }
  },
  methods: {
    isExternalFreeItem(item) {
      if (!item) return false
      const goodsType = item.goodsType
      const isExternalTab =
        this.currentId === '99' || goodsType === '99' || goodsType === 99
      return isExternalTab && Number(item.saleType) === 0
    },
    shouldDisableItem(item) {
      if (!item) return false
      if (this.isExternalFreeItem(item)) {
        return false
      }
      return this.disabledFn(item)
    },
    // 当前 tab 下条目的唯一标识：素材 tab 用 materialId，规格 tab 用 specId，其余用 goodsId
    getItemId(item) {
      if (!item) return undefined
      if (['51'].includes(this.currentId)) return item.specId
      if (['8', '9'].includes(this.currentId)) return item.materialId
      return item.goodsId
    },
    // 判断已选中的记录是否与当前 tab 属于同一 id 空间
    // checkList / checkListInfo 是跨 tab 共用的，不同 tab 的 id 可能数值相同，
    // 素材 tab 用 materialId、商品 tab 用 goodsId，若不区分会造成误判为"已选中"
    isSameIdSpace(item) {
      if (!item) return false
      // 素材 tab：商品记录（来自商品 tab）也可能有 materialId 字段，需要排除
      if (['8', '9'].includes(this.currentId)) return !item.goodsId
      // 商品 tab：素材记录没有 goodsId，天然不会与商品 id 相同
      return true
    },
    async handleRefreshItem(item) {
      const { code } = await updateMaterialStatus({
        mediaIds: item.materialId
      })
      if (code === 1) {
        this.$message({
          message: '刷新成功',
          type: 'success'
        })
        this.searchFn()
      }
    },
    getShelveFlagBgColor(shelveFlag) {
      const colors = { 0: '#E6F7EA', 1: '#FEECEC', 2: '#FFF2E6' }
      return colors[shelveFlag] || '#FFF2E6'
    },
    getShelveFlagClass(shelveFlag) {
      const colors = {
        0: 'el-icon-success',
        1: 'el-icon-error',
        2: 'el-icon-time'
      }
      return colors[shelveFlag] || 'el-icon-time'
    },
    get_packageCoure_checkList() {
      if (this.currentId !== 'A7') return
      // 套餐课判断是否选择了子项的直播课，判断 套餐课的选择状态
      // 根据checkList构建对象
      if (this.checkList.length === 0) {
        this.packageCoure_checkList = {}
        return
      }
      const packageCoure_checkList = {}
      this.checkList.map(v => {
        const arr = v.split('-')
        if (arr.length < 2) return
        if (packageCoure_checkList[arr[0]]) {
          packageCoure_checkList[arr[0]].push(arr[1])
        } else {
          packageCoure_checkList[arr[0]] = [arr[1]]
        }
      })
      this.packageCoure_checkList = packageCoure_checkList
      console.log(this.packageCoure_checkList, 'this.packageCoure_checkList')
    },
    init() {
      this.checkedAll = false
      this.packageCoure_checkList = {}
      this.current = 1
      // 拷贝一份再操作：弹窗内的勾选/全选会增删 checkList，若直接引用调用方传入的数组，
      // 点取消时调用方数据已被改动无法回滚，再次打开还会把未确认的勾选当成已选回显
      this.checkList = [...this.defaultValue]
      // 单选模式下，初始化 selectedSingleValue
      if (!this.multiple && this.defaultValue && this.defaultValue.length > 0) {
        this.selectedSingleValue = this.defaultValue[0]
      } else {
        this.selectedSingleValue = ''
      }
      this.get_packageCoure_checkList()
      this.tableData = []
      this.starSalePrice = undefined
      this.endSalePrice = undefined
      this.search = this.initSearch?.search || ''
      this.searchGoodsId = ''
      this.searchType = 1
      this.courseType = ''
      this.gradeTag = []
      // 有显示交付年级标签的权限时才加载年级信息树
      if (this.showGradeTagFilter && this.gradeTagOptions.length === 0) {
        this.getGradeTagOptions()
      }
      // 与 checkList 同理做拷贝，弹窗内的勾选增删不能直接影响调用方传入的回显数组
      this.checkListInfo = [...this.goodsInfo]
      // 重置多规格课程的已选规格
      this.selectedSkuMap = {}
      // 重置 selectedRoundGoods 相关状态
      this.roundGoodsLoadedPages = new Set()
      // selectedRoundGoods: 重置时保留取消勾选的状态，并从checkList和checkListInfo中移除已取消勾选的商品
      if (this.currentId === 'selectedRoundGoods') {
        // 从checkList中移除被取消勾选的商品ID
        this.checkList = this.checkList.filter(id => !this.roundGoodsUncheckedIds.has(id))
        // 从checkListInfo中移除被取消勾选的商品
        this.checkListInfo = this.checkListInfo.filter(item => !this.roundGoodsUncheckedIds.has(item.goodsId))
      } else {
        this.roundGoodsUncheckedIds = new Set()
      }
      this.tearch = {
        lecturerId: this.initSearch?.lecturerId || '',
        lecturerName: this.initSearch?.lecturerName || ''
      }
      console.log(this.checkList, this.checkListInfo, '1111')
      // console.log(this.tabList[0], 'this.tabList[0]')
      // this.changTab(this.tabList[0])
      // this.getList()
      if (['8', '9'].includes(this.currentId)) {
        this.getClassList()
      } else {
        this.getList()
      }
    },
    changTab(row) {
      console.log(this.tableData, 'tableData')
      this.selectedTableData = [...this.selectedTableData, ...this.tableData]
      this.uniqueArr = [
        ...new Map(
          this.selectedTableData.map(item => [item.goodsId, item])
        ).values()
      ]
      console.log(this.uniqueArr, 'uniqueArr')
      console.log(row, 'row')
      // this.search = ''
      this.currentId = row.name
      this.tableData = []
      this.current = 1
      this.total = 0
      this.checkedAll = false
      // this.getList()
      if (['8', '9'].includes(this.currentId)) {
        this.getClassList()
      } else {
        this.getList()
      }
    },
    handleSlortChage() {
      this.searchFn()
    },
    searchReset() {
      this.init()
    },
    getList() {
      console.log(this.currentId, 'this.currentId')
      if (this.isPlaform) {
        this.getPlatformGoodsList()
      } else if (
        ['0', '1', '2', '3', '4', '5', '10'].includes(this.currentId)
      ) {
        this.getGoodsList()
      } else if (['8', '9'].includes(this.currentId)) {
        this.getMaterialList()
      } else if (['6'].includes(this.currentId)) {
        this.getLiveList()
      } else if (['51'].includes(this.currentId)) {
        this.getOfflineGoodsSpecPage()
      } else if (['7'].includes(this.currentId)) {
        // 套餐课
        this.getPackagePage()
      } else if (['A7'].includes(this.currentId)) {
        this.getMaterialGoodsByType()
      } else if (['99'].includes(this.currentId)) {
        this.getGoodsWaiLianPage()
      } else if (['selectedRoundGoods'].includes(this.currentId)) {
        console.log('查询轮询商品')
        this.loadMerchantRoundGoods()
      }
    },
    loadMerchantRoundGoods() {
      this.loading = true
      const params = {
        current: this.current,
        size: this.size,
        contentName: this.searchType === 1 ? this.search : '',
        goodsId: this.searchType === 2 ? this.searchGoodsId : '',
        singleLecture: this.singleLecture,
        lecturerId: this.tearch.lecturerId,
        sortType: this.slort,
        ...this.params
      }
      getMerchantRoundGoods(params)
        .then(res => {
          this.tableData = res.data.records
          this.selectedTableData = [
            ...this.selectedTableData,
            ...this.tableData
          ]
          this.total = res.data.total

          const pageKey = `${this.current}-${this.size}`
          const isFirstLoad = !this.roundGoodsLoadedPages.has(pageKey)

          this.tableData.forEach((item, index) => {
            if (isFirstLoad) {
              // 第一次加载该页，默认选中所有数据（除非在取消列表中）
              if (!this.roundGoodsUncheckedIds.has(item.goodsId)) {
                this.checkChange(true, item, index)
              }
            } else {
              // 非第一次加载，恢复勾选状态
              if (this.checkList.includes(item.goodsId) &&
                  !this.roundGoodsUncheckedIds.has(item.goodsId)) {
                this.checkChange(true, item, index)
              }
            }
          })

          // 标记该页已加载
          this.roundGoodsLoadedPages.add(pageKey)
          this.checkData = [...this.tableData]
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    getGoodsWaiLianPage() {
      const params = {
        pageIndex: this.current,
        pageSize: this.size,
        goodsName: this.search,
        id: this.searchGoodsId,
        shelfStatus: 0
      }
      getExternalLinkGoodsPage(params).then(res => {
        // 外鏈商品返回的字段名與內容管理商品不同，這裡做一層字段映射，方便模板統一渲染
        const items = res.data.items || []
        items.some(u => {
          u.goodsPrice = u.goodsPrice / 100
        })
        this.tableData = items.map(item => ({
          ...item,
          // 統一成其它 tab 使用的字段
          goodsId: item.goodsId || item.id,
          coverVerticalUrl: item.coverVerticalUrl || item.goodsCover,
          contentName: item.contentName || item.goodsName,
          // 狀態、售賣類型字段兼容
          saleType: item.saleType,
          salePrice: item.goodsPrice,
          goodsType: '99',
          shelveFlag: item.shelveFlag ?? item.shelfStatus
        }))

        this.selectedTableData = [...this.selectedTableData, ...this.tableData]
        console.log(this.selectedTableData, 'this.%%%%%%%%%%@@@@@@@@@@:')
        // 兼容不同返回結構的 total
        this.total = res.data.total || items.length || 0
        this.loading = false
      })
      console.log('获取外链商品列表')
    },
    handleCurrentChange(val) {
      this.current = val
      this.tableData = []
      this.checkedAll = false
      this.getList()
    },
    handleSizeChange(val) {
      this.size = val
      this.current = 1
      this.tableData = []
      this.getList()
    },
    // 获取商品列表
    getGoodsList() {
      this.loading = true
      let onlineFlag = 0
      if (['5'].includes(this.currentId)) {
        onlineFlag = 1
      }
      const params = {
        current: this.current,
        size: this.size,
        contentName: this.searchType === 1 ? this.search : '',
        goodsId: this.searchType === 2 ? this.searchGoodsId : '',
        goodsType: this.currentId === '10' ? '8' : this.currentId,
        onlineFlag,
        singleLecture: this.singleLecture,
        shelveFlag: 0,
        starSalePrice: this.starSalePrice ? this.starSalePrice * 100 : '',
        endSalePrice: this.endSalePrice ? this.endSalePrice * 100 : '',
        lecturerId: this.tearch.lecturerId,
        curriculumType: this.initSearch?.curriculumType || undefined,
        sortType: this.slort,
        tagType: this.initSearch?.tagType || undefined
      }
      // 大专栏开启延迟发放权益：只查配置了实际交付年级标签的专栏
      if (this.showGradeTag) {
        params.hasGradeTag = 1
      }
      if (this.showGradeTagFilter) {
        params.gradeCode = this.gradeTag[0]
        params.textbookVersionCode = this.gradeTag[1]
      }
      if (this.filterateHidden) {
        params.notLikeContentName = '私域专享'
        params.shelveHideFlag = 0
        params.saleType = 1
      } else {
        delete params.notLikeContentName
        params.shelveHideFlag = ''
      }
      // 将外部传入的参数放在最后，确保不会被上面的逻辑删除
      Object.assign(params, this.params)
      if (this.tearchSearch) {
        params.lecturerId = this.tearch.lecturerId
      }
      getGoodsList(params)
        .then(res => {
          if (this.packagePrice) {
            res.data.records.map(v => {
              v.packagePrice = v.salePrice / 100
            })
          }
          console.log(res, 'res这是一个商品数据', this.packageChildren)
          res.data.records.map(v => {
            const index = this.packageChildren.findIndex(
              e => e.associateGoodsId === v.goodsId
            )
            index > -1 &&
              (v.packagePrice = this.packageChildren[index].packagePrice / 100)
          })

          this.tableData = res.data.records
          this.selectedTableData = [
            ...this.selectedTableData,
            ...this.tableData
          ]
          this.total = res.data.total
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleChange(value) {
      console.log(value, 'value111')
    },
    // 获取素材列表
    getMaterialList() {
      console.log('获取素材列表')
      this.loading = true
      let materialType = ''
      if (this.currentId === '8') {
        materialType = '2'
      } else if (this.currentId === '9') {
        materialType = '1'
      }
      const params = {
        materialType,
        current: this.current,
        size: this.size,
        materialName: this.search,
        dirId: this.form.id,
        sortType: this.slort
      }
      materialPage(params)
        .then(res => {
          this.tableData = res.data.records
          this.total = res.data.total
          // this.noMore = this.tableData.length >= this.total
          // this.current = this.current + 1
          this.selectedTableData = [
            ...this.selectedTableData,
            ...this.tableData
          ]
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 获取直播专栏列表
    getLiveList() {
      const params = {
        current: this.current,
        size: this.size
      }
      const index = this.tabList.findIndex(v => v.id === '6')
      const api = this.tabList[index].api || '/material/goods/page?goodsType=6'
      getLiveList(params, api)
        .then(res => {
          this.tableData = res.data.records
          this.total = res.data.total
          this.selectedTableData = [
            ...this.selectedTableData,
            ...this.tableData
          ]
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 获取套餐课详情
    getPackagePage() {
      this.loading = true
      const params = {
        current: this.current,
        size: this.size,
        contentName: this.searchType === 1 ? this.search : '',
        goodsId: this.searchType === 2 ? this.searchGoodsId : '',
        goodsType: this.currentId,
        onlineFlag: 0,
        singleLecture: this.singleLecture,
        shelveFlag: 0,
        starSalePrice: this.starSalePrice ? this.starSalePrice * 100 : '',
        endSalePrice: this.endSalePrice ? this.endSalePrice * 100 : '',
        lecturerId: this.tearch.lecturerId,
        curriculumType: this.initSearch?.curriculumType || undefined,
        sortType: this.slort,
        tagType: this.initSearch?.tagType || undefined
      }
      if (this.showCourseType) {
        params.courseType = this.courseType
      }
      if (this.tearchSearch) {
        params.lecturerId = this.tearch.lecturerId
      }

      if (this.filterateHidden) {
        params.notLikeContentName = '私域专享'
        params.shelveHideFlag = 0
        params.saleType = 1
      } else {
        delete params.notLikeContentName
        params.shelveHideFlag = ''
      }
      // 将外部传入的参数放在最后，确保不会被上面的逻辑删除
      Object.assign(params, this.params)
      if (this.tearchSearch) {
        params.lecturerId = this.tearch.lecturerId
      }
      getGoodsList(params)
        .then(res => {
          console.log(res, 'res++++++++++++')
          if (this.packagePrice) {
            res.data.records.map(v => {
              v.packagePrice = v.salePrice / 100
            })
          }
          res.data.records.map(v => {
            v.liveCourseNum = 0
            v.childrenOpen = false
            v.children &&
              v.children.map(e => {
                (e.goodsType === 3 || e.goodsType === 4) &&
                  e.productCategory === 1 &&
                  v.liveCourseNum++
                e._goodsId = v.goodsId + '-' + e.goodsId
                return
              })
            const index = this.packageChildren.findIndex(
              e => e.goodsId === v.goodsUd
            )
            index > -1 &&
              (v.packagePrice = this.packageChildren[index.packagePrice] / 100)
          })
          this.tableData = res.data.records
          console.log(this.tableData, 'this.tableData')
          this.total = res.data.total
          this.selectedTableData = [
            ...this.selectedTableData,
            ...this.tableData
          ]
          this.loading = false
        })
        .catch(err => {
          console.log(err)
          this.loading = false
        })
      console.log(params, 'params')
    },
    // 获取套餐课详情(直播用，不分页)
    getMaterialGoodsByType() {
      this.loading = true
      const params = {
        // current: this.current,
        // size: this.size,
        contentName: this.search,
        goodsType: 7,
        onlineFlag: 0,
        singleLecture: this.singleLecture,
        shelveFlag: 0,
        starSalePrice: this.starSalePrice ? this.starSalePrice * 100 : '',
        endSalePrice: this.endSalePrice ? this.endSalePrice * 100 : '',
        productCategory: this.courseType,
        lecturerId: this.tearch.lecturerId,
        curriculumType: this.initSearch?.curriculumType || undefined,
        sortType: this.slort,
        tagType: this.initSearch?.tagType || undefined
      }
      if (this.showCourseType) {
        params.courseType = this.courseType
      }
      if (this.tearchSearch) {
        params.lecturerId = this.tearch.lecturerId
      }

      if (this.filterateHidden) {
        params.notLikeContentName = '私域专享'
        params.shelveHideFlag = 0
        params.saleType = 1
      } else {
        delete params.notLikeContentName
        params.shelveHideFlag = ''
      }
      // 将外部传入的参数放在最后，确保不会被上面的逻辑删除
      Object.assign(params, this.params)
      if (this.tearchSearch) {
        params.lecturerId = this.tearch.lecturerId
      }
      getMaterialGoodsByType(params)
        .then(res => {
          if (this.packagePrice) {
            res.data.map(v => {
              v.packagePrice = v.salePrice / 100
            })
          }
          res.data.map(v => {
            v.liveCourseNum = 0
            v.childrenOpen = false
            v.children &&
              v.children.map(e => {
                (e.goodsType === 3 || e.goodsType === 4) &&
                  e.productCategory === 1 &&
                  v.liveCourseNum++
                e._goodsId = v.goodsId + '-' + e.goodsId
                return
              })
          })
          this.tableData = res.data
          this.selectedTableData = [
            ...this.selectedTableData,
            ...this.tableData
          ]
          this.total = res.data.length
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 获取线下课【规格】【获客交付】
    getOfflineGoodsSpecPage() {
      this.loading = true
      let onlineFlag = 0
      if (['5'].includes(this.currentId)) {
        onlineFlag = 1
      }
      const params = {
        current: this.current,
        size: this.size,
        goodsName: this.search,
        onlineFlag,
        shelveFlag: 0,
        sortType: this.slort,
        ...this.params,
        tagType: this.initSearch?.tagType || undefined
      }
      if (this.tearchSearch) {
        params.lecturerId = this.tearch.lecturerId
      }
      getOfflineGoodsSpecPage(params)
        .then(res => {
          this.tableData = res.data.records
          this.total = res.data.total
          this.selectedTableData = [
            ...this.selectedTableData,
            ...this.tableData
          ]
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    successFn() {
      console.log(this.tableData, 'this.tableData')
      const selectedData = this.tableData
        .filter(item => {
          const isSelected = (() => {
            if (['51'].includes(this.currentId)) {
              return this.checkList.includes(item.specId)
            } else if (['8', '9'].includes(this.currentId)) {
              return this.checkList.includes(item.materialId)
            } else if (['A7'].includes(this.currentId)) {
              if (this.packageCoure_checkList[item.goodsId]) {
                return this.packageCoure_checkList[item.goodsId].length > 0
              }
              return false
            } else if (['7'].includes(this.currentId)) {
              return this.checkList.includes(item.goodsId)
            } else {
              return this.checkList.includes(item.goodsId)
            }
          })()

          console.log(
            `Item ${
              item.goodsId || item.specId || item.materialId
            }: ${isSelected}`
          )
          return isSelected
        })
        .map(item => {
          if (['A7'].includes(this.currentId) && item.children) {
            // 对于套餐课,只返回已选中的子课程
            return {
              ...item,
              children: item.children.filter(child =>
                this.checkList.includes(child._goodsId)
              )
            }
          }
          return item
        })

      this.uniqueArr = [
        ...new Map(
          this.selectedTableData.map(item => [item.goodsId, item])
        ).values()
      ]
      const allData = []
      this.checkList.forEach(id => {
        const findItem = this.uniqueArr.find(item => item.goodsId === id)
        if (findItem) {
          allData.push(findItem)
        }
      })
      console.log(allData, 'allData')
      // return
      console.log(this.checkListInfo, this.checkList, selectedData, 'successFn')

      // selectedRoundGoods: 子组件直接处理取消选中商品的API调用，不调用父组件回调
      if (this.currentId === 'selectedRoundGoods') {
        // 无论是否有取消选中的商品，都调用API
        cancelMerchantToBusinessData({
          mchId: this.params.mchId,
          businessIds: Array.from(this.roundGoodsUncheckedIds)
        }).then(() => {
          // API调用成功后清空取消选中的商品ID
          this.roundGoodsUncheckedIds = new Set()
          this.visible = false
        }).catch(() => {
          this.visible = false
        })
        return
      }

      // selectSpec：勾选了多规格课程必须都指定具体规格，并把选中规格挂载到返回数据上
      if (this.selectSpec) {
        const lackSpecItem = this.checkListInfo.find(
          v => this.isMultiSpec(v) && !this.selectedSkuMap[v.goodsId]
        )
        if (lackSpecItem) {
          this.$message.warning(
            `课程【${lackSpecItem.contentName}】为多规格课程，请选择具体规格`
          )
          return
        }
        this.checkListInfo.forEach(v => {
          if (this.isMultiSpec(v)) {
            const selectedSku = this.selectedSkuMap[v.goodsId]
            if (selectedSku) {
              // 统一字段，调用方无需关心线上/线下课差异：
              // - specValue：提交接口用的规格唯一标识（线下课 specId，线上课 skuCode）
              // - specLabel：展示用规格名称（线下课 specName，线上课 skuDesc）
              const isOffline = Number(v.goodsType) === 5
              v.selectedSku = {
                ...selectedSku,
                specValue: isOffline
                  ? (selectedSku.specId ?? selectedSku.warehouseSkuId)
                  : (selectedSku.skuCode ?? selectedSku.warehouseSkuId),
                specLabel: isOffline
                  ? (selectedSku.specName ?? selectedSku.skuDesc)
                  : (selectedSku.skuDesc ?? selectedSku.specName),
                warehouseSkuId: isOffline
                  ? (selectedSku.specId ?? selectedSku.onlineId ?? selectedSku.id ?? selectedSku.warehouseSkuId)
                  : (selectedSku.warehouseSkuId ?? selectedSku.skuCode)
              }
            } else {
              v.selectedSku = selectedSku
            }
          }
        })
      }

      // 选了相同老师课程
      const res = this.success(
        this.checkListInfo,
        this.checkList,
        selectedData,
        allData
      )
      if (Object.prototype.toString.call(res) === '[object Promise]') {
        return res.then(() => {
          this.visible = false
        })
      } else if (!res) {
        this.visible = false
      }
    },
    close() {
      this.visible = false
    },
    checkChange(res, item, index) {
      if (this.multiple) {
        // 多选
        if (res) {
          // 勾选前校验（如大专栏延迟发放权益场景的年级标签重复校验），返回错误文案则回滚勾选
          // 注意：el-checkbox-group 的 v-model 已把该项加入 checkList，拦截时需同步移除
          if (typeof this.beforeCheck === 'function') {
            const errorMsg = this.beforeCheck(item, this.checkListInfo)
            if (errorMsg) {
              const checkIndex = this.checkList.indexOf(item.goodsId)
              if (checkIndex > -1) {
                this.checkList.splice(checkIndex, 1)
              }
              this.$message.error(errorMsg)
              this.loading = false
              return
            }
          }
          // 添加
          this.checkListInfo.push(item)
          // 多规格课程：勾选时自动默认选中第一个规格，避免需要二次交互
          this.ensureDefaultSkuSelected(item)
          // selectedRoundGoods: 从取消列表中移除，并添加到checkList
          if (this.currentId === 'selectedRoundGoods') {
            this.roundGoodsUncheckedIds.delete(item.goodsId)
            if (!this.checkList.includes(item.goodsId)) {
              this.checkList.push(item.goodsId)
            }
          }
        } else {
          // 删除
          console.log('this.currentId', this.currentId)
          const i = this.checkListInfo.findIndex(v => {
            if (
              ['0', '1', '2', '3', '4', '5', '6', '7', '10', '99', 'selectedRoundGoods'].includes(
                this.currentId
              )
            ) {
              return v.goodsId === item.goodsId
            } else if (['51'].includes(this.currentId)) {
              return v.specId === item.specId
            } else {
              return v.materialId === item.materialId
            }
          })
          console.log(i, 'i')
          if (i >= 0) this.checkListInfo.splice(i, 1)
          this.clearInvalidSkuSelection()
          // selectedRoundGoods: 添加到取消列表，并从checkList中移除
          if (this.currentId === 'selectedRoundGoods') {
            this.roundGoodsUncheckedIds.add(item.goodsId)
            const checkIndex = this.checkList.indexOf(item.goodsId)
            if (checkIndex > -1) {
              this.checkList.splice(checkIndex, 1)
            }
          }
        }
      } else {
        // 单选
        this.checkListInfo = []
        this.checkList = []
        this.checkListInfo.push(item)
        if (['51'].includes(this.currentId)) {
          this.checkList.push(item.specId)
          this.selectedSingleValue = item.specId
        } else {
          this.checkList.push(item.goodsId)
          this.selectedSingleValue = item.goodsId
        }
        // 多规格课程：勾选时自动默认选中第一个规格，避免需要二次交互
        this.ensureDefaultSkuSelected(item)
        this.clearInvalidSkuSelection()
      }

      // selectedRoundGoods: 根据当前页选中状态更新全选框
      if (this.currentId === 'selectedRoundGoods' && this.multiple) {
        // 获取当前页所有未禁用的商品
        const currentPageItems = this.tableData.filter(item => !this.shouldDisableItem(item))
        // 检查这些商品是否都被选中
        const allChecked = currentPageItems.length > 0 &&
          currentPageItems.every(item => this.checkList.includes(item.goodsId))
        this.checkedAll = allChecked
      }

      this.loading = false
    },
    // 点击搜索
    searchFn() {
      this.current = 1
      this.tableData = []
      // selectedRoundGoods: 搜索时重置已加载页面的记录，但保留取消勾选的状态
      if (this.currentId === 'selectedRoundGoods') {
        this.roundGoodsLoadedPages = new Set()
      }
      this.getList()
    },
    // 加载交付年级标签树形选项（年级-教材版本）
    async getGradeTagOptions() {
      try {
        const res = await getGradeVersionTree()
        this.gradeTagOptions = res.data || []
      } catch (e) {
        this.gradeTagOptions = []
      }
    },
    async getClassList() {
      this.treeLoading = true
      this.form = {
        id: '',
        name: ''
      }
      const res = await store.dispatch('option/getClass')
      if (this.currentId === '9') {
        this.classlist = res.audioClass
        this.listType = 'list'
      } else if (this.currentId === '8') {
        this.classlist = res.videoClass
      }
      this.treeLoading = false
      this.getList()
    },
    treeClick(data, node) {
      console.log('点击触发', data)
      this.form.id = data.id === '-1' ? '' : data.id
      this.form.name = data.dirName
      this.current = 1
      this.getList()
    },
    // 选择讲师触发回调事件
    teacherSelect(val) {
      this.tearch.lecturerId = val.lecturerId
      this.tearch.lecturerName = val.lecturerName
      this.searchFn()
    },
    // 获取默认提示语
    getPlaceholder() {
      const index = this.tabList.findIndex(v => v.id === this.currentId)
      if (index > -1) {
        return this.tabList[index].placeholder
          ? this.tabList[index].placeholder
          : '请输入关键词'
      } else {
        return '请输入关键词'
      }
    },
    // 获取平台课程
    // 获取商品列表
    getPlatformGoodsList() {
      this.loading = true
      let onlineFlag = 0
      if (['5'].includes(this.currentId)) {
        onlineFlag = 1
      }
      const params = {
        current: this.current,
        size: this.size,
        contentName: this.searchType === 1 ? this.search : '',
        goodsId: this.searchType === 2 ? this.searchGoodsId : '',
        goodsType: this.currentId === '10' ? '8' : this.currentId,
        onlineFlag,
        singleLecture: this.singleLecture,
        starSalePrice: this.singleLecture,
        endSalePrice: this.endSalePrice,
        shelveFlag: 0,
        ...this.params,
        lecturerId: this.tearch.lecturerId,
        curriculumType: this.initSearch?.curriculumType || undefined,
        sortType: this.slort
      }
      if (this.filterateHidden) {
        params.notLikeContentName = '私域专享'
        params.shelveHideFlag = 0
        params.saleType = 1
      } else {
        delete params.notLikeContentName
        params.shelveHideFlag = ''
        delete params.saleType
      }
      if (this.tearchSearch) {
        params.lecturerId = this.tearch.lecturerId
      }
      platformGoodsList(params)
        .then(res => {
          res.data.records.map(v => {
            v.childrenOpen = false
          })
          this.tableData = res.data.records
          this.total = res.data.total
          this.loading = false
          this.selectedTableData = [
            ...this.selectedTableData,
            ...this.tableData
          ]
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 套餐课点击触发
    onClickPackageCourse(value, item, index) {
      if (this.loading) return
      console.log(this.loading, this.check, value, this.checkList, value)
      this.loading = true
      if (this.check.includes(item._goodsId) || this.shouldDisableItem(item)) {
        return
      }
      const i = this.checkList.findIndex(v => v === value)
      console.log(i, 'i')
      i > -1 ? this.checkList.splice(i, 1) : this.checkList.push(value)
      this.checkChange(i === -1, item, index)
    },
    // A7套餐课点击触发
    onClickA7PackageCourse(value, c_item, index, item) {
      if (
        !(
          (c_item.goodsType === 3 || c_item.goodsType === 4) &&
          c_item.productCategory === 1
        ) ||
        this.check.includes(c_item._goodsId) ||
        this.shouldDisableItem(c_item)
      ) {
        return
      }
      if (this.changeLoading) return
      this.changeLoading = true
      const i = this.checkList.findIndex(v => v === value)
      const c_index = this.checkListInfo.findIndex(
        v => v.goodsId === item.goodsId
      )

      if (i > -1) {
        // 删除
        this.checkList.splice(i, 1)
        if (
          this.checkListInfo[c_index] &&
          this.checkListInfo[c_index].children
        ) {
          const c_index_chidren = this.checkListInfo[
            c_index
          ].children.findIndex(v => v._goodsId === c_item._goodsId)
          c_index_chidren > -1 &&
            this.checkListInfo[c_index].children.splice(c_index_chidren, 1)
        }
      } else {
        // 添加
        this.checkList.push(value)
        if (c_index > -1) {
          this.checkListInfo[c_index] &&
            this.checkListInfo[c_index].children.push(c_item)
        } else {
          this.checkListInfo.push({
            ...item,
            children: [c_item]
          })
        }
      }

      this.changeLoading = false
      console.log(this.checkListInfo, this.checkList)
      // this.checkChange(value, item, index)
    },
    // 套餐课全选直播课
    onClickPackageA7Course(value, item, index, res) {
      if (item.liveCourseNum === 0 || this.shouldDisableItem(item)) {
        return
      }

      if (!this.multiple) {
        // 单选
        this.checkList = []
        this.checkListInfo = []
      }

      const obj = this.tableData.find(v => v.goodsId === value)
      if (obj && obj.children) {
        const ids = []
        const childrenArr = []
        obj.children.map(v => {
          if (
            (v.goodsType === 3 || v.goodsType === 4) &&
            v.productCategory === 1
          ) {
            ids.push(v._goodsId)
            childrenArr.push(v)
          }
        })
        const index = this.checkListInfo.findIndex(v => v.goodsId === value)
        // 多选
        if (res) {
          // 全选
          this.checkList = [...new Set([...this.checkList, ...ids])]
          index > -1
            ? (this.checkListInfo[index] = childrenArr)
            : this.checkListInfo.push({ ...obj, children: childrenArr })
        } else {
          // 全取消
          this.checkList = this.checkList.filter(
            element => !ids.includes(element)
          )
          index > -1 && this.checkListInfo.splice(index, 1)
        }
      }
    },
    onhandleOpen(item) {
      item.childrenOpen = !item.childrenOpen
      if (item.childrenOpen) {
        this.$nextTick(() => {
          const element = document.getElementById(
            `packageCoure-check-view-group${item.goodsId}`
          )
          element.scrollIntoView({
            behavior: 'smooth' // 平滑滚动效果
          })
        })
      }
    },
    ifCheckAll(item) {
      if (
        Object.getOwnPropertyNames(this.packageCoure_checkList).length === 0
      ) {
        return false
      }
      if (!this.packageCoure_checkList[item.goodsId]) {
        return false
      }
      if (
        this.packageCoure_checkList[item.goodsId] &&
        this.packageCoure_checkList[item.goodsId].length === 0
      ) {
        return false
      }
      if (
        this.packageCoure_checkList[item.goodsId] &&
        this.packageCoure_checkList[item.goodsId].length !== item.liveCourseNum
      ) {
        return false
      }
      return true
    },
    handleCheckAll() {
      if (this.checkedAll) {
        // A7（套餐课直播版）的 checkList 存的是 `goodsId-childGoodsId` 组合 key，
        // 与下面的通用逻辑不兼容，保持原有行为：全选不处理
        if (['A7'].includes(this.currentId)) return
        const isMaterialTab = ['8', '9'].includes(this.currentId)
        const arr = this.tableData.filter(i => {
          const id = this.getItemId(i)
          // 禁选（已关联）的条目不参与全选
          if (this.check.includes(id)) return false
          // 素材 tab 的禁用规则在模板里单独处理（转码中），保持原有行为
          if (!isMaterialTab && this.shouldDisableItem(i)) return false
          return true
        })
        arr.forEach(i => {
          const id = this.getItemId(i)
          // 逐项去重：先手动勾一条再点全选时，这一条已经存在于 checkListInfo 中，
          // 若直接 push 会导致最终提交的选中数据多一条。
          // 需同时限定同一 id 空间，避免跨 tab 的同值 id 被误判为"已选中"
          const existInfo =
            id !== undefined &&
            id !== null &&
            this.checkListInfo.some(
              v => this.isSameIdSpace(v) && this.getItemId(v) === id
            )
          if (!existInfo) {
            this.checkListInfo.push(i)
          }
          // checkList 与 checkListInfo 可能不同步（回显时 defaultValue / goodsInfo 可能只传其一），
          // 这里只补齐缺失的 id，不覆盖已有的
          if (!this.checkList.includes(id)) {
            this.checkList.push(id)
          }
        })
        // selectedRoundGoods: 全选当前页时，从取消列表中移除当前页的商品
        if (this.currentId === 'selectedRoundGoods') {
          arr.forEach(item => {
            this.roundGoodsUncheckedIds.delete(item.goodsId)
          })
        }
      } else {
        // selectedRoundGoods: 取消全选时，只取消当前页的商品，并添加到取消列表
        if (this.currentId === 'selectedRoundGoods') {
          // 获取当前页的商品ID
          const currentPageIds = this.tableData.map(item => item.goodsId)
          // 从checkList中移除当前页的商品ID
          this.checkList = this.checkList.filter(id => !currentPageIds.includes(id))
          // 从checkListInfo中移除当前页的商品
          this.checkListInfo = this.checkListInfo.filter(item => !currentPageIds.includes(item.goodsId))
          // 将当前页的商品添加到取消列表
          currentPageIds.forEach(id => {
            this.roundGoodsUncheckedIds.add(id)
          })
        } else {
          // 其他情况保持原有逻辑
          this.checkList.splice(0, this.checkList.length)
          const item = this.tableData[0]
          const index = this.checkListInfo.findIndex(v => {
            if (
              ['0', '1', '2', '3', '4', '5', '6', '7', '10', '99'].includes(
                this.currentId
              )
            ) {
              return v.goodsId === item.goodsId
            } else if (['51'].includes(this.currentId)) {
              return v.specId === item.specId
            } else {
              return v.materialId === item.materialId
            }
          })
          this.checkList.splice(index, this.tableData.length)
          this.checkListInfo.splice(index, this.tableData.length)
        }
      }
    },
    formatPrice(item) {
      if (!item) return ''
      const filtersMoney = this.$options.filters?.filtersMoney
      const isExternal =
        item.goodsType === '99' ||
        item.goodsType === '99' ||
        this.currentId === '99'
      if (isExternal) {
        const price =
          item.goodsPrice !== undefined ? item.goodsPrice : item.salePrice
        if (price === undefined || price === null || price === '') return ''
        if (filtersMoney && !Number.isNaN(Number(price))) {
          return filtersMoney(Number(price) * 100)
        }
        return price
      }
      const price = item.salePrice
      if (filtersMoney && price !== undefined && price !== null) {
        return filtersMoney(price)
      }
      return price || ''
    },
    // 是否多规格课程：
    // - 普通课程：multiWarehouseSkuList（[{skuCode, skuDesc, skuPrice}]）
    // - 线下课：onlineList（[{salePrice, maxSalePrice, ...}]）
    isMultiSpec(item) {
      if (!item) return false
      return this.getSpecList(item).length > 0
    },
    // 多规格数量标签（只统计可展示的规格）
    multiSpecCount(item) {
      if (!item) return 0
      return this.getSpecList(item).length
    },
    // 多规格 sku 列表（线下课用 onlineList，其它用 multiWarehouseSkuList）
    // enableFlag 为 0 表示已禁用的规格：过滤不展示
    getSpecList(item) {
      if (!item) return []
      if (Array.isArray(item.multiWarehouseSkuList) && item.multiWarehouseSkuList.length > 0) {
        return item.multiWarehouseSkuList.filter(sku => Number(sku.enableFlag) !== 0)
      }
      if (Number(item.goodsType) === 5 && Array.isArray(item.onlineList) && item.onlineList.length > 0) return item.onlineList
      return []
    },
    // 库存不足（skuStock 或线下课 availableNum 为 0）：置灰禁选，并追加库存不足文案
    isSkuOutOfStock(sku) {
      if (!sku) return false
      return [sku.skuStock, sku.availableNum].some(stock => stock === 0 || stock === '0')
    },
    // 多规格 sku 唯一 key（用于 v-for :key）
    getSpecKey(sku) {
      if (!sku) return ''
      return sku.skuCode || sku.skuDesc || sku.id || sku.specId || sku.salePrice || sku.maxSalePrice || Math.random()
    },
    // 多规格 sku 展示文案（线下课：specName + salePrice~maxSalePrice；其它：skuDesc + skuPrice）
    getSpecLabel(sku) {
      if (!sku) return ''
      // 线下课 onlineList 项
      if (sku.salePrice !== undefined || sku.maxSalePrice !== undefined) {
        const min = sku.salePrice ?? 0
        const max = sku.maxSalePrice ?? sku.salePrice ?? 0
        const filtersMoney = this.$options.filters?.filtersMoney
        let priceText = ''
        if (min === max) {
          priceText = filtersMoney ? filtersMoney(Number(min)) : (Number(min) / 100).toFixed(2)
        } else {
          const minText = filtersMoney ? filtersMoney(Number(min)) : (Number(min) / 100).toFixed(2)
          const maxText = filtersMoney ? filtersMoney(Number(max)) : (Number(max) / 100).toFixed(2)
          priceText = `${minText} ~ ${maxText}`
        }
        return `${sku.specName || ''} ￥${priceText}`
      }
      // 线上课 multiWarehouseSkuList 项
      return `${sku.skuDesc || ''} ￥${this.formatSkuPrice(sku)}`
    },
    // 线下课顶层 salePrice / maxSalePrice 兜底：onlineList 为空时直接用顶层价格
    offlineTopLevelPrice(item) {
      if (!item) return null
      const min = item.salePrice
      const max = item.maxSalePrice
      if (min === undefined && max === undefined) return null
      const filtersMoney = this.$options.filters?.filtersMoney
      const fmt = v => filtersMoney ? filtersMoney(Number(v)) : (Number(v) / 100).toFixed(2)
      const minVal = min !== undefined ? Number(min) : Number(max)
      const maxVal = max !== undefined ? Number(max) : Number(min)
      return minVal === maxVal ? fmt(minVal) : `${fmt(minVal)} ~ ${fmt(maxVal)}`
    },
    // 是否按多规格展示价格区间（showMultiSpecTag 开启且为多规格课程）
    // 不强求 saleType === 1：线下课返回的 saleType 字段可能是 0/undefined，只要 onlineList/multiWarehouseSkuList 有值就展示
    showRangePrice(item) {
      return (
        this.showMultiSpecTag &&
        this.isMultiSpec(item)
      )
    },
    // 多规格价格区间：
    // - 线下课：onlineList[].salePrice ~ .maxSalePrice（分）；onlineList 为空时用顶层 salePrice/maxSalePrice
    // - 普通课程：multiWarehouseSkuList[].skuPrice（分）
    specPriceRange(item) {
      // 线下课多规格：onlineList
      if (Number(item?.goodsType) === 5) {
        if (Array.isArray(item?.onlineList) && item.onlineList.length > 0) {
          const allPrices = []
          item.onlineList.forEach(o => {
            if (o.salePrice !== undefined && o.salePrice !== null) allPrices.push(Number(o.salePrice))
            if (o.maxSalePrice !== undefined && o.maxSalePrice !== null) allPrices.push(Number(o.maxSalePrice))
          })
          if (!allPrices.length) return this.formatPrice(item)
          const min = Math.min(...allPrices)
          const max = Math.max(...allPrices)
          const filtersMoney = this.$options.filters?.filtersMoney
          if (!filtersMoney) return min === max ? min : `${min} ~ ${max}`
          return min === max ? filtersMoney(min) : `${filtersMoney(min)} ~ ${filtersMoney(max)}`
        }
        // onlineList 为空：用顶层 salePrice/maxSalePrice 兜底
        const topPrice = this.offlineTopLevelPrice(item)
        if (topPrice !== null) return topPrice
      }
      // 普通多规格：multiWarehouseSkuList（getSpecList 已过滤禁用的规格）
      const list = this.getSpecList(item).filter(
        s => s.skuPrice !== undefined && s.skuPrice !== null && s.skuPrice !== ''
      )
      if (!list.length) return this.formatPrice(item)
      const prices = list.map(s => Number(s.skuPrice))
      const min = Math.min(...prices)
      const max = Math.max(...prices)
      const filtersMoney = this.$options.filters?.filtersMoney
      if (!filtersMoney) return min === max ? min : `${min} ~ ${max}`
      return min === max
        ? filtersMoney(min)
        : `${filtersMoney(min)} ~ ${filtersMoney(max)}`
    },
    // 规格单价（分转元）
    formatSkuPrice(sku) {
      const filtersMoney = this.$options.filters?.filtersMoney
      if (
        filtersMoney &&
        sku.skuPrice !== undefined &&
        sku.skuPrice !== null &&
        !Number.isNaN(Number(sku.skuPrice))
      ) {
        return filtersMoney(Number(sku.skuPrice))
      }
      return sku.skuPrice ?? ''
    },
    // 课程类型标签配色：直播课/直播专栏-蓝；大专栏-紫；线下课-橙；专栏/套餐课-绿；其他-灰
    goodsTypeTagClass(goodsType) {
      const type = Number(goodsType)
      if (type === 8 || type === 6) return 'type-tag--blue'
      if (type === 4) return 'type-tag--purple'
      if (type === 5) return 'type-tag--orange'
      if (type === 3 || type === 7) return 'type-tag--green'
      return 'type-tag--gray'
    },
    // selectSpec 模式：选择多规格课程的具体规格
    handleSelectSku(item, sku) {
      if (this.isSkuOutOfStock(sku)) return
      this.$set(this.selectedSkuMap, item.goodsId, sku)
    },
    // 多规格课程必须选一个规格：勾选时若未选任何规格，默认选中第一个有库存的
    ensureDefaultSkuSelected(item) {
      if (!this.selectSpec) return
      if (!this.isMultiSpec(item)) return
      if (this.selectedSkuMap[item.goodsId]) return
      const first = this.getSpecList(item).find(sku => !this.isSkuOutOfStock(sku))
      if (first) {
        this.$set(this.selectedSkuMap, item.goodsId, first)
      }
    },
    isSkuSelected(item, sku) {
      const selected = this.selectedSkuMap[item.goodsId]
      if (!selected) return false
      // 用引用比较：规格对象是数组元素本身，勾选/切换时都是同一个对象
      return selected === sku
    },
    // 清理已选规格中不在 checkList 里的记录（取消勾选/单选切换时调用）
    clearInvalidSkuSelection() {
      Object.keys(this.selectedSkuMap).forEach(goodsId => {
        if (!this.checkList.includes(goodsId)) {
          delete this.selectedSkuMap[goodsId]
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.search_btn {
  width: 68px;
  height: 32px;
  border-radius: 4px;
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  > span {
    font-size: 14px;
  }
}
.search_btn + .search_btn {
  margin-left: 0;
}
.search_paramy {
  background: #0c6fff;
  color: #fff;
}
.choose_resource {
  .delay-grant-tip {
    display: inline-block;
    margin: 0 20px 10px;
    padding: 8px 12px;
    background: #fdf6ec;
    color: #e6a23c;
    font-size: 13px;
    border-radius: 4px;
  }
  .window-search {
    position: relative;
    height: 36px;
    line-height: 36px;
    margin: 20px 20px 10px 20px;
    display: flex;
    align-items: center;
    .order-time-box {
      display: flex;
    }
    .input-with-select {
      width: 108px;
      height: 32px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #333333;
      border-radius: 3px 0px 0px 3px;
    }
    .filter_teacherSelect {
      ::v-deep {
        .el-input__inner {
          border-radius: 0px 3px 3px 0px;
        }
      }
    }
    .input-with-select-chang {
      ::v-deep .el-input__inner {
        border: none;
        border-radius: 3px 0px 0px 3px;
        border: 1px solid #d8dce6;
        border-right: none;
      }
    }
    .text {
      margin-right: 8px;
      color: #333333;
      font-family: 'Microsoft YaHei';
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
    }
    .moneyBox {
      display: flex;
      align-items: center;
    }
  }
  .window-tab {
    margin: 0 20px;
    display: flex;
    justify-content: space-between;
    .tab-wrapper {
      display: flex;
      width: 100%;
      height: inherit;
      border-bottom: 1px solid #eeeeee;
      .tab-item {
        // padding: 0 20px;
        // width: 70px;
        width: 100%;
        height: 100%;
        line-height: 40px;
        // position: relative;
        // bottom: -1px;
        // text-align: center;
        // cursor: pointer;
      }
      .tab-active {
        border-bottom: 2px solid #2a75ed;
        color: #2a75ed;
      }
    }
  }
  .window-list {
    width: 100%;
    height: 396px;
    // overflow-y: scroll;
    // padding: 0 20px;
    box-sizing: border-box;
    position: relative;
    // 显示「延迟发放权益」提示条时，列表高度同步收窄提示条占用的高度（约46px），
    // 否则列表底部会溢出弹窗主体并遮挡底部确定/取消按钮，导致点击无响应
    &.with-grade-tip {
      ::v-deep .resource-item-wrapper .resource-item-wrapper-box {
        height: 458px;
      }
    }

    &::-webkit-scrollbar {
      width: 8px;
      height: 10px;
      background-color: rgba(0, 0, 0, 0);
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 6px;
      background-color: rgba(0, 0, 0, 0.2);
      transition: all 0.4s ease;
      -moz-transition: all 0.4s ease;
      -webkit-transition: all 0.4s ease;
      -o-transition: all 0.4s ease;
    }
    &::-webkit-scrollbar-track {
      background-color: rgba(0, 0, 0, 0.1);
    }
    ::v-deep {
      .resource-item-wrapper {
        width: 100%;
        padding: 0 20px;
        min-height: 72px;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;
        -o-align-items: center;
        align-items: center;
        .resource-item-wrapper-box {
          padding: 0 20px;
          height: 504px;
          width: 100%;
          box-sizing: border-box;
          overflow: auto;
        }
        .el-checkbox-group {
          width: 100%;
          display: flex;
          flex-direction: column;
          .el-checkbox {
            width: 100%;
            display: flex;
            align-items: center;
            padding: 15px 0;
            min-height: 72px;
            border-bottom: 1px solid #eeeeee;
            &__input {
              line-height: 1;
              white-space: nowrap;
              cursor: pointer;
              outline: none;
              display: inline-block;
              position: relative;
              vertical-align: middle;
            }
            &__label {
              display: flex;
              flex: 1;
              align-items: center;
              overflow: hidden;
            }
            .resource-item-wrapper-box-group {
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 1267px;
              .item-wrapper {
                display: flex;
                flex: 1;
                overflow: hidden;
                display: flex;
                align-items: center;
                cursor: pointer;
                line-height: 1;
                text-overflow: ellipsis;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                > img {
                  width: 60px;
                  height: 60px;
                  border-radius: 2px;
                  margin-right: 10px;
                  border: 0;
                  vertical-align: middle;
                }
                > .image-previewer {
                  width: 60px;
                  height: 60px;
                  border-radius: 2px;
                  margin-right: 10px;
                  border: 0;
                  vertical-align: middle;
                  background: rgb(245, 247, 250);
                }
                .item-info {
                  // max-width: 550px;
                  flex: 1;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  -webkit-line-clamp: 1;
                  -webkit-box-orient: vertical;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  min-height: 60px;
                  .item-name {
                    // max-width: 480px;
                    height: 20px;
                    line-height: 20px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-bottom: 6px;
                    color: #353535;
                  }
                  .item-price {
                    height: 24px;
                    line-height: 24px;
                    display: inline-block;
                    color: #fb6161;
                  }
                }
                .item-grade-tag {
                  line-height: 24px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  color: #919293;
                  font-size: 12px;
                  margin-left: 10px;
                }
              }
              .packageInputView {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                padding-left: 10px;
                .packageInputViewText {
                  color: #333333;
                  font-family: 'Microsoft YaHei';
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 22px;
                  margin-right: 8px;
                }
                .el-input__inner {
                  text-align: left;
                }
              }
              .item-wrapper-left {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                padding-left: 10px;
                width: 68px;
                height: 32px;
                flex-shrink: 0;
                border-radius: 4px;
                border: 1px solid #dcdfe5;
                background: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                .btn-left {
                  color: #0c6fff;
                  font-family: 'Microsoft YaHei';
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 14px;
                }
              }
            }
          }
        }

        .el-radio-group {
          width: 100%;
          display: flex;
          flex-direction: column;
          .el-radio {
            width: 100%;
            display: flex;
            align-items: center;
            padding: 15px 0;
            min-height: 72px;
            border-bottom: 1px solid #eeeeee;
            &__input {
              line-height: 1;
              white-space: nowrap;
              cursor: pointer;
              outline: none;
              display: inline-block;
              position: relative;
              vertical-align: middle;
            }
            &__label {
              display: flex;
              flex: 1;
              align-items: center;
              overflow: hidden;
            }
          }
        }

        > .ss-material-main-tree {
          width: 100%;
          display: flex;
          height: 504px;
          .ss-material-main-tree-left {
            width: 210px;
            border: 1px solid #ebebeb;
            margin-right: 10px;
          }
          .ss-material-main-tree-right {
            width: calc(100% - 200px);
            height: 504px;
            overflow: auto;
          }
        }
      }
    }
  }

  .resource-item-wrapper-box {
    .item-wrapper {
      display: flex;
      align-items: center;
      > .item-info {
        margin-left: 25px;
      }
      .image-previewer {
        width: 60px;
        height: 60px;
      }
      .item-price {
        color: red;
      }
    }
    .packageCoure-check-view-group {
      width: 100%;
      padding: 15px 0;
      min-height: 72px;
      border-bottom: 1px solid #eeeeee;
      .packageCoure-item-wrapper-box-group {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 1267px;
        .packageCoure-item-wrapper {
          display: flex;
          flex: 1;
          overflow: hidden;
          display: flex;
          align-items: center;
          cursor: pointer;
          line-height: 1;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          > img {
            width: 60px;
            height: 60px;
            border-radius: 2px;
            margin-right: 10px;
            border: 0;
            vertical-align: middle;
          }
          > .image-previewer {
            width: 60px;
            height: 60px;
            border-radius: 2px;
            margin-right: 10px;
            border: 0;
            vertical-align: middle;
            background: rgb(245, 247, 250);
          }
          .packageCoure-item-info {
            // max-width: 550px;
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            min-height: 60px;
            .item-name {
              // max-width: 480px;
              height: 20px;
              line-height: 20px;
              font-weight: 500;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin-bottom: 6px;
              color: #353535;
            }
            .item-price {
              height: 24px;
              line-height: 24px;
              display: inline-block;
              color: #fb6161;
            }
            .item-chidren-name {
              display: flex;
              align-items: center;
              .item-name {
                margin-bottom: 0;
                max-width: 1000px;
              }
              .item-chidren-type {
                height: 16px;
                line-height: 16px;
                font-size: 12px;
                padding: 0 7px;
                border-radius: 12px;
                background: #f7e7e6;
                color: #a13a00;
              }
              .item-chidren-type-live {
                background: #e6f7ea;
                color: #00b42a;
              }
              .item-chidren-type-offline {
                background: #ffe7d0;
                color: #8b3a00;
              }
            }
          }
        }
        > .packageCoure-item-wrapper-left {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding-left: 10px;
          width: 68px;
          height: 32px;
          flex-shrink: 0;
          border-radius: 4px;
          border: 1px solid #dcdfe5;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          .btn-left {
            color: #0c6fff;
            font-family: 'Microsoft YaHei';
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 14px;
          }
        }
      }
      .packageCoure-item-children {
        max-height: 413px;
        overflow: auto;
      }
    }
  }
}
.size-icon {
  width: 40px;
  height: 40px;
  cursor: pointer;
  margin-right: 20px;
}
img {
  object-fit: contain;
  background: #f5f7fa;
}
.dialogFooter {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px;
  box-sizing: border-box;
  // 兜底：列表区域（position:relative 的定位元素）溢出弹窗主体时会盖住底部按钮，
  // 提升按钮区层级并加底色，保证确定/取消按钮始终可点
  position: relative;
  z-index: 2;
  background: #fff;
  .dialogFooterRight {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
.noData {
  width: 100%;
  text-align: center;
  padding: 20px;
}
::v-deep {
  .el-tabs__header {
    margin: 0;
  }
  .el-pagination__jump {
    margin-left: 0;
  }
  // .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  //   padding-left: 20px;
  // }
  .el-tabs__nav-wrap::after {
    height: 0px;
  }
  .noMultiple {
    .el-checkbox__inner {
      border-radius: 50%;
    }
  }
}
.resource-item-wrapper-box-noData {
  padding-top: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  > img {
    width: 405px;
    height: 202px;
    background: #fff;
  }
  > .noDataText {
    margin-top: 10px;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    color: #919293;
    line-height: 26px;
  }
}
.tab-slort {
  display: flex;
  align-items: center;
  > span {
    width: 60px;
  }
}
.check-all {
  margin-left: 20px;
  margin-top: 5px;
  margin-right: 20px;
}
/* 多规格数量标签 / 课程类型标签 / 规格选择面板 */
.item-name-line {
  display: flex;
  align-items: center;
  overflow: hidden;
  .item-name {
    flex: 1;
    min-width: 0;
  }
}
.item-info-row2 {
  display: flex;
  align-items: center;
}
/* 占位撑开：保证左侧信息与右侧标签/价格之间始终有最小间距 */
.item-row2-gap {
  flex: 1;
  min-width: 20px;
}
.item-spec-count {
  flex-shrink: 0;
  margin-left: 8px;
  padding: 0 8px;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  color: #ed7b2f;
  background: #fff2e6;
  border-radius: 9px;
}
.item-type-tag {
  flex-shrink: 0;
  margin-left: auto;
  padding: 0 10px;
  height: 22px;
  line-height: 22px;
  font-size: 12px;
  border-radius: 11px;
  &.type-tag--blue {
    color: #0c6fff;
    background: #e8f1ff;
  }
  &.type-tag--purple {
    color: #7a4bd6;
    background: #f2ecff;
  }
  &.type-tag--orange {
    color: #ed7b2f;
    background: #fff2e6;
  }
  &.type-tag--green {
    color: #00b42a;
    background: #e6f7ea;
  }
  &.type-tag--gray {
    color: #86909c;
    background: #f2f3f5;
  }
}
/* 价格右对齐：有类型标签时紧邻标签右侧，无标签时靠最右 */
.item-price--right {
  flex-shrink: 0;
  margin-left: auto;
}
.item-type-tag + .item-price--right {
  margin-left: 10px;
}
.spec-select-panel {
  margin-top: 8px;
  padding: 10px 12px;
  background: #f7f8fa;
  border-radius: 4px;
}
.spec-select-options {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.spec-option {
  // 重置 button 浏览器默认样式
  appearance: none;
  outline: none;
  background: #fff;
  font-family: inherit;
  // tab 式选中样式
  padding: 5px 14px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #4e5969;
  font-size: 13px;
  cursor: pointer;
  &.active {
    border-color: #0c6fff;
    color: #0c6fff;
    background: #e8f1ff;
  }
  &:hover {
    border-color: #0c6fff;
    color: #0c6fff;
  }
  // 库存不足：置灰不可选
  &.spec-option--disabled,
  &.spec-option--disabled:hover {
    border-color: #e4e7ed;
    color: #c0c4cc;
    background: #f5f7fa;
    cursor: not-allowed;
  }
}
</style>
